<template>
  <div style="float: left;margin-top: 10px;">
    <div class="m-form__group m-form__group--inline">
      <div class="m-form__label">
        <label style="width: 100px;text-align:right;">{{label}}：</label>
      </div>
      <div class="m-form__control">
        <el-select v-model="value" filterable placeholder="全部" @change="change">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="item in options" :key="item.RoleID" :label="item.RoleName" :value="item.RoleID">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="d-md-none m--margin-bottom-10"></div>
  </div>
</template>

<script>
export default {
  name: 'SearchRoleSelect',
  data () {
    return {
      options: [],
      value: ''
    }
  },
  props: {
    label: {
      type: String
    }
  },
  methods: {
    change: function (selVal) {
      this.$emit('input', selVal)
    }
  },
  mounted: function () {
    var that = this
    var args = {
      token: sessionStorage.getItem('token'),
      currentPage: 1,
      pageSize: 99999
    }
    this.$utils.HttpPost(this.$utils.Url.system + '/systemapi/role/list', args, function (data) {
      that.options = data.Data
    }, null, null, null)
  }
}
</script>

<style scoped="scoped">
  .el-select {
    width: 100%;
  }
</style>
